import React from 'react';

import styles from './styles.module.css';

const Disclosure = () => (
  <div className="row">
    <div className="col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
      <div className={styles.subscribePrivacyTermsandConditions}>
        <span className="fa fa-lock"></span>
        <div>We value your privacy and security</div>
        <div className="mt1">
          By clicking “Subscribe” you agree to our Terms of Service and our Payment Policy.
          Subscriptions will automatically renew until you cancel. Prices are subject to change.
          This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service
          apply.
        </div>
      </div>
    </div>
  </div>
);

export default Disclosure;
